import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {reduxForm, Field, SubmissionError} from 'redux-form'
import RenderPasswordFormGroup from '../Form/RenderPasswordFormGroup'
import RenderInputFormGroup from "../Form/RenderInputFormGroup"
import RenderCaptchaInput from '../Form/RenderCaptchaInput'
import {required, email, captcha} from "../Form/rules"
import {outerUrls} from '../../../settings/routes'
import {handleSignupRequest, successProfileResponse} from '../../../modules/profile'
import {captchaHashSelector, handleGetCaptchaHash, translationsLocaleSelector} from "../../../modules/app"
import {formatErrorMessage} from "../../../helpers/common"
import ReCAPTCHA from "react-google-recaptcha";
import Axios from 'axios'
import CheckboxField from '../../helpers/Fields/CheckboxField'

class Signup extends Component{

    constructor(props) {
        super(props)
        this.state = {
            error_message: ''
        }
    }

    componentDidMount(){
        const queryParams = new URLSearchParams(window.location.search)
        const referal_code = queryParams.get("referal_code");
        if(referal_code){
            console.log("🚀 ~ file: Signup.js ~ line 30 ~ Signup ~ componentDidMount ~ referal_code", referal_code)
            localStorage.setItem('referalCode', referal_code)
        }
    }

    submit(values) {
        let {username, firstname, lastname, email, gender, password, captcha, is_organisation = 0 } = values;
        this.setState({error_message: ''})

        if(email.indexOf('@tempinbox.com') > 0){
            throw new SubmissionError({ email: 'Invalid email address' });
        }



        return handleSignupRequest({username, firstname, lastname, email, gender, password, captcha, is_organisation, referal_code: localStorage.getItem('referalCode')})
            .then(successProfileResponse({dispatch: this.props.dispatch, toMainPage:true, isReduxForm : true}))
            .catch(error => {
                this.props.dispatch(handleGetCaptchaHash());

                const err_field = {}
                if(error.errors._error && typeof error.errors._error == 'string'){
                    this.setState({error_message: error.errors._error})
                }

                if(error.errors && error.errors.message && Object.keys(error.errors.message).length){
                    Object.keys(error.errors.message).forEach(key => {
                        if(error.errors.message[key] && error.errors.message[key][0]){
                            err_field[key] = error.errors.message[key][0];
                        }
                    });
                }
                
                throw new SubmissionError({
                    ...err_field,
                    // _error : formatErrorMessage(error.message),
                })
            })
    }
    

    render() {
        let {handleSubmit, error, submitting, submitSucceeded, } = this.props
        let {formatMessage} = this.context

        return (
            <div className="auth-form-wrapper">
                <h1 className="h2 text-center">{formatMessage('Signup')}</h1>
                <p className="text-center">{formatMessage('Please fill out the following fields to signup:')}</p>
                {this.state.error_message ? <p className="text-center text-danger">{formatErrorMessage(this.state.error_message)}</p> : null}
                <form className="profile-form" onSubmit={handleSubmit(this.submit.bind(this))}>
                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "username"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("User name")}:`}
                                id = "username"
                                validate = {[required]}
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "firstname"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("First name")}:`}
                                id = "firstname"
                                validate = {[required]}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "lastname"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("Last name")}:`}
                                id = "lastname"
                                validate = {[required]}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "email"
                                type = "text"
                                component = {RenderInputFormGroup}
                                label = {`${formatMessage("Email")}:`}
                                id = "email"
                                validate = {[required, email]}
                            />
                        </div>
                    </div>

                    <div className="form-group" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end'}}>
                        <div>
                            <p>{formatMessage("Gender")}:</p>
                            <label className="radio-inline custom-radio">
                                <Field
                                    component="input"
                                    name="gender"
                                    type="radio"
                                    id="male"
                                    value="1"
                                /> {formatMessage("Male")}
                                <span className="custom-radio-span"></span>
                            </label>
                            <label className="radio-inline custom-radio">
                                <Field
                                    component="input"
                                    name="gender"
                                    type="radio"
                                    id="female"
                                    value="2"
                                /> {formatMessage("Female")}
                                <span className="custom-radio-span"></span>
                            </label>
                        </div>
                        <div>
                            <Field
                                component={CheckboxField}
                                name="is_organisation"
                                type="int"
                                style={{marginBottom: 0}}
                                label={formatMessage('codeOrganisationSignUp')}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <Field
                                name = "password"
                                type = "password"
                                component = {RenderPasswordFormGroup}
                                label = {`${formatMessage("Password")}:`}
                                id = "password"
                                validate = {[required]}
                                autoComplete="off"
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <div style={{marginBottom: 10}}>
                                <ReCAPTCHA
                                    sitekey="6Le6bMgUAAAAAPgzmYcBfRJxXpbSnlenhQ1C297N"
                                    onExpired={() => {
                                        this.props.change('captcha', null)
                                    }}
                                    onErrored={() => {
                                        this.props.change('captcha', null)
                                    }}
                                    onChange={async(token) => {
                                        try {
                                            const instance = Axios.create();
                                            instance.defaults.headers = {}
                                            const secret= '6Le6bMgUAAAAABLLmFJFhVt75hxHSdqKtheitB0t';

                                            let {data} = await instance.post(`https://www.google.com/recaptcha/api/siteverify?secret=${secret}&response=${token}`, {}, {
                                                // crossDomain: true
                                                headers: {
                                                    "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
                                                }
                                            });
                                        } catch (error) {
                                            this.props.change('captcha', 'yes')
                                        }
                                    }}
                                />
                                <Field 
                                    name = "captcha" 
                                    type="hidden"
                                    validate = {[required]} 
                                    component={RenderInputFormGroup}
                                />
                            </div>
                        
                            {/* <Field
                                name = "captcha"
                                type = "captcha"
                                component = {RenderCaptchaInput}
                                label = {`${formatMessage("Verify Code")}:`}
                                id = "captcha"
                                validate = {[required]}
                                autoComplete="off"
                            /> */}
                        </div>
                    </div>

                    {
                        submitSucceeded &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-success">
                                <p>{formatMessage("Check your email.")}</p>
                            </div>
                        </div>
                    }

                    {
                        error &&
                        <div className="row">
                            <div className="col-xs-12 text-center text-danger">
                                <p>{formatMessage(error)}</p>
                            </div>
                        </div>
                    }

                    <div className="row">
                        <div className="col-xs-12">
                            <div className="form-group">
                                <button className="btn btn-primary btn-block" type="submit" disabled={submitting}>{formatMessage("Signup")}</button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <p className="help-block text-center">{formatMessage('By clicking this button, you agree to Question Bank Manager')} <a href={outerUrls.privacyPolicy} target="_blank">{formatMessage('Privacy Policy')}</a> {formatMessage('and')} <a href={outerUrls.termsOfUse} target="_blank">{formatMessage('Terms of Use')}</a>.</p>
                    </div>
                </form>
            </div>
        )
    }

    static contextTypes = {formatMessage: PropTypes.any}
}


export default connect(
    state => ({
        captchaHash : captchaHashSelector(state),
        locale : translationsLocaleSelector(state),
    }),
    null,
    null,
    {pure: false}
)(reduxForm({
    form: 'signup',
    // onSubmit : (values, dispatch) => {
        
    // },
    pure: false,
})(Signup))


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/common/Auth/Signup.js